<template>
    <div class="floor used">
		<!-- 楼层标题 -->
		<div class="floor_title">
		    <div class="floor_title_content">
		        <span class="floor_title_border"></span>
		        <span class="floor_title_content_index">{{ floorConfig.index || "二手设备出售&租赁" }}</span>
		        <span class="floor_title_content_text">{{ floorConfig.title || "" }}</span>
		    </div>
		    <div class="other-title" >
		        <router-link to="/used">查看更多<i class="iconfont iconarrow-right"></i></router-link>
		    </div>
		</div>
        <!-- 楼层内容区 -->
		<div class="floor-content">
			<div class="goods-info" v-if="usedList.length">
				<div class="item" v-for="(item, index) in usedList" :key="item.goods_id" @click="$router.pushToTab({ path: '/used-detail-' + item.id })">
					<img class="img-wrap" :src="$img(item.thumb)" @error="item.thumb = defaultGoodsImage" />
					<div class="price-wrap">
						<div class="price" v-if="item.price <=0">
							<!-- <p>￥</p> -->
							面议
						</div>
						<div class="price" v-else>
							<p>￥</p>
							{{ item.price }}
						</div>
						<div class="area">
							{{ item.area.name }}
						</div>
						<!-- <div class="market-price">￥{{ item.market_price }}</div> -->
					</div>
					<div class="goods-name">{{ item.title }}</div>
					<div class="shop_name">{{item.site.site_name}}</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { usedList } from "@/api/cms/used"
	
    export default {
        name: "used",
        components: {
        },
        props: {
            config: {
                type: Object,
                // required: true
            }
        },
        data() {
            return {
                floorConfig: {
                    validated: false,
                    rightCargos: []
                },
                usedList: [],
				
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
            this.getusedList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            toused(item) {
                if (item) {
                    this.$router.pushToTab(`/list?used_id=${item.used_id}`)
                }
            },
            getusedList() {
                // const sku_ids = this.floorConfig.rightCargos
                //     .map(item => {
                //         return item.sku_id
                //     })
                //     .toString()
				
                usedList({
					page_size:8
				})
                    .then(res => {
                        this.usedList = res.data.list
                    })
                    .catch(err => {})
            }
        },
        watch: {
            config: {
                handler: function(curr) {
                    if (curr && curr.rightCargos) {
                        this.floorConfig = { ...curr, validated: true }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .floor {
		width: 1210px;
		&_title {
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    padding-right: 20px;
		    &_border {
		        display: inline-block;
		        width: 5px;
		        height: 28px;
		        background-color: $base-color;
		        margin-right: 12px;
		        vertical-align: top;
		    }
		
		    &_content {
		        font-size: 20px;
		        padding-top: 10px;
		        padding-bottom: 10px;
		        height: 48px;
		        line-height: 28px;
		        // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
		        box-sizing: border-box;
		
		        &_index {
		            display: inline-block;
		            color: $ns-text-color-black;
		            padding-right: 8px;
		            font-weight: 600;
		        }
		
		        &_text {
		            font-weight: 600;
		            display: inline-block;
		            color: $base-color;
		        }
		    }
			.other-title {
			    a {
			        color: #838383;
			
			        i {
			            font-size: 14px;
			        }
			
			        &:hover {
			            color: $base-color;
			        }
			    }
			}
		}
        .floor-content {
            display: flex;
            flex-wrap: wrap;
			background-color: #fff;
			.goods-info {
				margin-top: 5px;
				display: flex;
				flex-wrap: wrap;
			
				.item {
					width: 295px;
					margin: 10px 10px 0 0;
					border: 1px solid #eeeeee;
					// padding-top: 10px;
					position: relative;
					padding-bottom: 5px;
					box-sizing: border-box;
					overflow: hidden;
					&:nth-child(4n) {
						margin-right: initial !important;
					}
			
					&:hover {
						border: 1px solid $base-color;
					}
			
					.img-wrap {
						width: 100%;
						height: 198px;
						cursor: pointer;
						padding: 10px;
						box-sizing: border-box;
					}
			
					.goods-name {
						padding: 0 10px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
						word-break: break-all;
						height: 25px;
						cursor: pointer;
			
						&:hover {
							color: $base-color;
						}
					}
			
					.price-wrap {
						padding: 0 10px;
						display: flex;
						align-items: center;
						
						.price {
							display: flex;
							color: $base-color;
							font-size: $ns-font-size-lg;
			
							p {
								font-size: $ns-font-size-base;
								display: flex;
								align-items: flex-end;
							}
						}
						
						.area {
							flex: 1;
							color: #5f5f5f;
							// text-decoration: line-through;
							margin-right: 0;
							text-align: right;
							
						}
					}
			
					.sale-num {
						padding: 0 10px;
						display: flex;
						color: #838383;
						font-size: $ns-font-size-sm;
			
						p {
							color: #4759a8;
						}
					}
			
					.shop_name {
						padding: 0 10px;
						display: flex;
						color: #838383;
					}
			
					.saling {
						padding: 0 10px;
						display: flex;
						font-size: $ns-font-size-sm;
						line-height: 1;
			
						.free-shipping {
							background: $base-color;
							color: #ffffff;
							padding: 3px 4px;
							border-radius: 2px;
							margin-right: 5px;
						}
			
						.is_own {
							color: #ffffff;
							background: #ff850f;
							border: 1px solid;
							margin-right: 5px;
							display: flex;
							align-items: center;
							padding: 3px 4px;
							border-radius: 2px;
						}
			
						.promotion-type {
							color: $base-color;
							border: 1px solid $base-color;
							display: flex;
							align-items: center;
							padding: 1px 3px;
						}
					}
			
					.item-bottom {
						display: flex;
						margin-top: 5px;
			
						.collection {
							flex: 1;
							border: 1px solid #e9e9e9;
							border-right: none;
							border-left: none;
							height: 40px;
							display: flex;
							align-items: center;
							justify-content: center;
							cursor: pointer;
						}
			
						.cart {
							flex: 2;
							border: 1px solid #e9e9e9;
							border-right: none;
							height: 40px;
							display: flex;
							align-items: center;
							justify-content: center;
							cursor: pointer;
						}
					}
				}
			}
			
			.empty {
				margin-top: 45px;
			}
        }
    }
</style>
